/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MaterialProperty from './MaterialProperty';
import MonitoringControllerDtoNftCarListNftCarData from './MonitoringControllerDtoNftCarListNftCarData';

/**
 * The MonitoringControllerDtoNftCarListResponse model module.
 * @module model/MonitoringControllerDtoNftCarListResponse
 * @version 1.0
 */
class MonitoringControllerDtoNftCarListResponse {
    /**
     * Constructs a new <code>MonitoringControllerDtoNftCarListResponse</code>.
     * @alias module:model/MonitoringControllerDtoNftCarListResponse
     */
    constructor() { 
        
        MonitoringControllerDtoNftCarListResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MonitoringControllerDtoNftCarListResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MonitoringControllerDtoNftCarListResponse} obj Optional instance to populate.
     * @return {module:model/MonitoringControllerDtoNftCarListResponse} The populated <code>MonitoringControllerDtoNftCarListResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MonitoringControllerDtoNftCarListResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('totalCount')) {
                obj['totalCount'] = ApiClient.convertToType(data['totalCount'], 'Number');
            }
            if (data.hasOwnProperty('list')) {
                obj['list'] = ApiClient.convertToType(data['list'], [MonitoringControllerDtoNftCarListNftCarData]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MonitoringControllerDtoNftCarListResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MonitoringControllerDtoNftCarListResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        if (data['list']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['list'])) {
                throw new Error("Expected the field `list` to be an array in the JSON data but got " + data['list']);
            }
            // validate the optional field `list` (array)
            for (const item of data['list']) {
                MonitoringControllerDtoNftCarListNftCarData.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
MonitoringControllerDtoNftCarListResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
MonitoringControllerDtoNftCarListResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
MonitoringControllerDtoNftCarListResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
MonitoringControllerDtoNftCarListResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
MonitoringControllerDtoNftCarListResponse.prototype['contentsReward'] = undefined;

/**
 * @member {Number} totalCount
 */
MonitoringControllerDtoNftCarListResponse.prototype['totalCount'] = undefined;

/**
 * @member {Array.<module:model/MonitoringControllerDtoNftCarListNftCarData>} list
 */
MonitoringControllerDtoNftCarListResponse.prototype['list'] = undefined;






export default MonitoringControllerDtoNftCarListResponse;

